import React, { createContext } from "react";
import { useOrchestratorContext, OrchestratorContext } from "./OrchestratorContext.js";
export const CheckoutPaxContext = createContext(undefined);
export default function OrchestratorProvider(props) {
    const orchestrator = useOrchestratorContext();
    return React.createElement(OrchestratorContext.Provider, { value: orchestrator }, props.children);
}
